import React from 'react';
// styles
import { Wrapper } from './RatingStars.styles';

const RatingStars = ({ rating }) => {
  let ratingStarsArray = [];

  if (rating === 0) {
    for (let i = 0; i < 5; i++) {
      ratingStarsArray.push(<i class='bi bi-star'></i>);
    }
  } else {
    let starsNum = rating;
    let showHalfStar = false;

    if (Math.trunc(rating) < rating) {
      starsNum = Math.trunc(rating);
      showHalfStar = true;
    }

    for (let i = 0; i < 5; i++) {
      if (starsNum === 0) {
        if (showHalfStar) {
          ratingStarsArray.push(<i class='bi bi-star-half'></i>);
          showHalfStar = false;
        } else {
          ratingStarsArray.push(<i class='bi bi-star'></i>);
        }
        continue;
      }

      ratingStarsArray.push(<i class='bi bi-star-fill'></i>);
      starsNum--;
    }
  }

  return (
    <Wrapper>
      {rating > 0 ? (
        ratingStarsArray.map((star) => star)
      ) : (
        <h3 className='info'>Not Rated</h3>
      )}
    </Wrapper>
  );
};

export default RatingStars;
